import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import LoginPage from '@/pages/LoginPage';
import HomePage from '@/pages/HomePage';
import ProjectWorkspacePage from '@/pages/ProjectWorkspacePage';
import MaterialsPage from '@/pages/MaterialsPage';
import SuppliersPage from '@/pages/SuppliersPage';
import MaterialConsumptionPage from '@/pages/MaterialConsumptionPage';
import UsersPage from '@/pages/UsersPage';
import AccountPage from '@/pages/AccountPage';
import AuditLogsPage from '@/pages/AuditLogsPage';
import SystemPage from '@/pages/SystemPage';
import UpdaterPage from '@/pages/UpdaterPage';
import BrandingPage from '@/pages/BrandingPage';
import InstallPage from '@/pages/InstallPage';
import LicensePage from '@/pages/LicensePage';
import MonitoringPage from '@/pages/MonitoringPage';
import AppShell from '@/layout/AppShell';
import { useTheme } from '@/context/ThemeContext';

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--fpccs-bg)] text-[var(--fpccs-text-muted)]">
        Memuat...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell><Outlet /></AppShell>;
}

function AdminRoute() {
  const { user } = useAuth();
  return user?.role === 'admin' ? <Outlet /> : <Navigate to="/" replace />;
}

function App() {
  const { resolvedTheme } = useTheme();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects/:pid" element={<ProjectWorkspacePage />} />
            <Route path="/materials" element={<MaterialsPage />} />
            <Route path="/suppliers" element={<SuppliersPage />} />
            <Route path="/projects/:pid/material-consumption" element={<MaterialConsumptionPage />} />
            <Route path="/account" element={<AccountPage />} />
            <Route path="/settings" element={<SettingsRedirect />} />
            <Route element={<AdminRoute />}>
              <Route path="/users" element={<UsersPage />} />
              <Route path="/audit-logs" element={<AuditLogsPage />} />
              <Route path="/system" element={<SystemPage />} />
              <Route path="/updater" element={<UpdaterPage />} />
              <Route path="/branding" element={<BrandingPage />} />
              <Route path="/license" element={<LicensePage />} />
              <Route path="/monitoring" element={<MonitoringPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme={resolvedTheme} position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

function SettingsRedirect() {
  const { user } = useAuth();
  return <Navigate to={user?.role === 'admin' ? '/users' : '/account'} replace />;
}

export default App;
